import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  FootprintsApiEndpointService,
  ProductsApiEndpointService,
} from '@nibtravel/shared/util/url';
import { Observable } from 'rxjs';
import {
  IDonation,
  IDonationConfig,
  IFundableProject,
} from '@nibtravel/shared/util/models';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FootprintsDataService {
  constructor(
    private http: HttpClient,
    private productsApiEndpointService: ProductsApiEndpointService,
    private footprintsApiEndpointService: FootprintsApiEndpointService
  ) {}

  loadDonations(brandCode: string): Observable<IDonation[] | undefined> {
    const url = this.productsApiEndpointService.getDonationConfigUrl(brandCode);
    return this.http.get<IDonationConfig>(url).pipe(
      map((data) => {
        if (data?.homeCountryDonationConfigs?.length > 0) {
          const donationBands =
            data?.homeCountryDonationConfigs?.[0].donationBands;
          const donations = donationBands?.map((item) => {
            return {
              value: item.defaultDonationAmount,
              isSelected: false,
            };
          });

          return [{ value: 0, isSelected: true }, ...donations];
        }
        return undefined;
      })
    );
  }

  /**
   * isSelected does not exist on the API, so mapping here to avoid null checks later on
   * and also pre-selecting here for 3 reasons:
   * 1. Once the object is assigned to state, ngxs transforms the object to readonly to ensure immutability
   * 2. Heavily simplify logic to pre-select on selector/or component
   * 3. The project loading should only happen the first time it loads, so this wouldn't run multiple times
   *    and wouldn't clash with a potential pre-selected value as it wouldn't exist anyways
   */
  loadFundableProjects(
    partnerCode: string,
    countryCodes: string[]
  ): Observable<IFundableProject[]> {
    const url = this.footprintsApiEndpointService.getFundableProjectsUrl(
      partnerCode,
      countryCodes
    );
    return this.http.get<IFundableProject[]>(url).pipe(
      map((projects) =>
        projects.map((p, index) => ({ ...p, isSelected: index === 0 }))
      ),
      shareReplay(1)
    );
  }
}
